<template lang="pug">
  v-form(ref="form")
    div.px-4.pt-4
      //- Tier level add/minus
      div.d-flex.flex-column.align-center.py-4
        p.s1 {{$t('how_many_tier')}}
        div.d-flex.align-center.mb-2
          v-btn.my-auto(icon small :disabled="disableMinus" @click="changingTiers.pop()")
            v-icon(color="black" size="21") mdi-minus-circle
          v-spacer
          div.quantity-box.text-center.mx-3
            span.body-1 {{ tierCount }}
          v-spacer
          v-btn.my-auto(icon small @click="addTier")
            v-icon(color="black" size="21") mdi-plus-circle

    v-divider.my-4.basic300
    v-container.pa-4
      //- Tier setting
      div.s1 {{$t('tier_setting')}}
      div.p2 {{$t('name_and_type_commission_structure')}}
      //- Tier listing
      div.my-3(v-for="(tier, tierIndex) in changingTiers" :key="`tier-${tierIndex}`")
        div.d-flex
          p.my-3.label.basic600--text.text-uppercase {{$t('tier')}} {{ tierIndex + 1 }}
          v-spacer
          v-btn.mr-3(icon small :disabled="changingTiers.length === 1" @click="selectedTierIndex = tierIndex; openConfirmDeleteDialog = true")
            eva-icon(name="trash-2-outline" width="20" height="20" :fill="$vuetify.theme.themes[$theme].primary500")
        v-text-field(v-model="tier.name" background-color="basic200" :placeholder= "$t('tier_name')" outlined dense :rules="rules.not_empty" hide-details="auto")
        div.mt-4
          div.py-2.px-4.mt-2.clickable(v-for="commissionType in commissionTypeList" :style="tier.commission_type.includes(commissionType.value)? 'border:2px solid var(--v-textColorAccent); background: var(--v-infoT08); border-radius: 4px;' : 'border:1px solid var(--v-basic300); border-radius: 4px;'" @click="updateCommissionType(commissionType.value, tierIndex)" :key="`${commissionType.value}-${tierIndex}`")
            .s1 {{ commissionType.text }}
        v-divider.mt-6.mb-4.basic300(v-if="tierIndex < changingTiers.length - 1")

    .dialogs
      //- Confirm delete
      y-dialog(v-model='openConfirmDeleteDialog', persistent max-width="320")
        v-card
          v-card-text.p1.primary500--text.pa-6
            div {{$t('are_you_sure')}}
              span.font-weight-bold {{$t('delete_tier')}}{{ selectedTierIndex + 1 }}
          v-card-actions
            v-spacer
            v-btn(color="white", text @click="openConfirmDeleteDialog = false")
              .button-Aa-small.primary400--text {{$t('cancel')}}
            v-btn.mr-2(color="danger500" depressed height=32 @click="deleteTier" dark)
              .button-AA-small.basic100--text {{$t('delete')}}
</template>

<script>
export default {
  name: 'CompanyTiers',
  props: {
    isNew: {
      type: Boolean
    },
    companyTiers: {
      type: Array,
      required: true
    }
  },
  data(vm) {
    return {
      changingTiers: [],
      commissionTypeList: [
        { text: vm.$t('percentage'), value: 'percentage' },
        { text: vm.$t('fix_amount_in')+`${this.$currency.symbol} `, value: 'amount' }
      ],
      newData: {
        name: null,
        commission_type: 'percentage'
      },
      rules: {
        not_empty: [val => (val || '').length > 0 || 'This field is required'],
        has_quantity: [v => !!v || 'This field is required', v => v != 0 || 'This field is required'],
        selected: [v => !!v || 'This field is required', v => v != 0 || 'This field is required'],
        weight: [v => !!v || 'This field is required', v => v >= 0.1 || 'Weight should not be below 0.1 KG', v => v <= 60 || 'Weight should not be above 60 KG'],
        weight2: [v => !v || v >= 0.1 || 'Weight should not be below 0.1 KG', v => !v || v <= 60 || 'Weight should not be above 60 KG']
      },
      selectedTierIndex: null,
      openConfirmDeleteDialog: false,
    }
  },
  mounted() {
    // Default new data
    if (this.isNew) {
      this.changingTiers = [
        { ...this.newData, tier: 1 },
        { ...this.newData, tier: 2 }
      ]
      return
    }
    // Clone existing data
    this.changingTiers = [...this.companyTiers]
  },
  computed: {
    disableMinus() {
      if (this.changingTiers.length === 1) {
        return true
      }
      return false
    },
    tierCount() {
      return this.changingTiers.length
    }
  },
  methods: {
    addTier() {
      const newData = {
        ...this.newData,
        tier: this.changingTiers.length + 1
      }
      this.changingTiers.push(newData)
    },
    updateCommissionType(val, index) {
      this.changingTiers[index].commission_type = val
    },
    deleteTier() {
      this.changingTiers.splice(this.selectedTierIndex, 1)
      this.openConfirmDeleteDialog = false
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>

<i18n>
{
  "en": {
    "percentage":"Percentage %",
    "tier_name":"Tier name",
    "fix_amount_in": "Fix amount in ",
    "how_many_tier":"How many Tier/Level of Commission?",
    "tier_setting":"Tier setting",
    "name_and_type_commission_structure":"Set the name and type of commission structure for each Tier",
    "tier":"Tier",
    "are_you_sure":"Are you sure you want to ",
    "delete_tier":"delete Tier "
  },

  "id": {
    "percentage":"Persentase %",
    "tier_name":"Ketik Nama Tingkat",
    "fix_amount_in": "Jumlah dalam ",
    "how_many_tier":"Berapa banyak Tingkat/Level dari Komisi?",
    "tier_setting":"Pengaturan tingkat",
    "name_and_type_commission_structure":"Tetapkan nama dan tipe struktur komisi berdasarkan masing-masing Tingkat",
    "tier":"Tingkat",
    "are_you_sure":"Kamu yakin ingin ",
    "delete_tier":"menghapus Tingkat "

  }


}
</i18n>